<template>
  <div style="display: flex;">
    <div style="padding: 0 20px;">
      <!-- 说明 -->
      <div style="display: flex; align-items: center; margin-right: -16px;">
        <div style="line-height: 24.5px;margin: 20px 0; flex: 1;font-weight: 600;">
          {{$I18n("carousel_card")}}
        </div>
        <md-switch class="small-switch" v-model="openIndexList"/>
      </div>
      <!-- 添加图片 -->
      <div style="position:relative;display: flex;overflow-x: auto;max-width: 500px;">
        <div style="margin-left: -6px;">
          <div @click="clickTwoInput" class="icon-image-select-box-two">
            <div class="image-box-info">
              <div class="span"> + </div>
            </div>
            <div class="mask"></div>
            <div v-if="isuploadimage" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index) in indexList.urls" :key="index">
          <div class="icon-image-select-box-two" :class="bannerImage === item.url ?'selected':''" @click="bannerImage = item.url">
            <img :src="item.url" width="160" height="68"/>
            <div class="mask"></div>
            <div class="setting-btn" @click="() => setBannerUrl(item,index)">
              <md-icon class="setting-btn-icon">settings</md-icon>
            </div>
          </div>
        </div>
      </div>
      <input style="display: none;" ref="file_two_input" type="file" @change="onTwoFileChange" />
    </div>
    <!-- 图片展示 -->
    <div style="flex:1;text-align: center;">
      <phone-two :icon_src="bannerImage"/>
      <div style="text-align: center;">
        {{$I18n("import_info_03")}}
      </div>
    </div>
    <!-- banner 详情 -->
    <simple-modal ref="bannermodal" :title="$I18n('details')" :right="true" :submitBtn="true" @submit="banner_submit">
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 弹窗-表单 -->
        <div class="md-layout">
          <common-form-item 
            v-for="item in form_modalBannerData" 
            v-model="bannerSetting.data[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
      <template slot="footer-btn">
        <md-button class="left-icon md-warning" @click="banner_sure_delete">{{$I18n("delete")}}</md-button>
      </template>
    </simple-modal>
    <simple-modal ref="bannerdeletemodal" :title="''" :submitBtn="true" @submit="banner_delete">
      <div slot="body">{{$I18n("is_sure_del")}}</div>
    </simple-modal>
  </div>
</template>
<script>
import PhoneTwo from './PhoneTwo.vue';
const simpleLang = ["en", "zh-CN"];
export default {
  name: "res-mng",
  components: { PhoneTwo },
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
  },
  data(){
    return {
      isuploadimage: false,   // 是否正在上传图片
      mouseMove: true,        // 鼠标重新移动了
      intervalUploadImage: 0, // 定时器 Interval
      rotatedeg: 0, // loarding角度
      // 2
      indexList: {
        state: 1,
        urls : [],
      },
      bannerSetting:{ // 修改、删除banner用的参数
        data:{},
        index:0,
      },
      bannerImage: "", // 条展示的图片
    }
  },
  mounted(){
    this.api_getUrl()
      .then(() => {
        if(!this.indexList.id){
          this.$api.addAppImgUrl({
            master_id: this.app_id,
            state    : 1,
            key      : "banner",
            urls     : [],
          })
            .then(() => {
              this.api_getUrl();
            })
        }
      })
    document.addEventListener('mousemove', this.handleMouseMove);
  },
  beforeDestroy(){
    document.removeEventListener('mousemove', this.handleMouseMove);
    clearInterval(this.intervalUploadImage)
  },
  watch:{
    // 启动、关闭 loading 转圈
    isuploadimage(newValue){
      if(newValue){
        this.intervalUploadImage = setInterval(() => {
          this.rotatedeg = this.rotatedeg + 10;
          if(this.rotatedeg > 360){
            this.rotatedeg = this.rotatedeg - 360
          }
        } , 30)
      } else {
        clearInterval(this.intervalUploadImage);
        this.rotatedeg = 0;
      }
    },
    openIndexList(){
      setTimeout(() => {this.switchBanner()}, 100);
    },
  },
  methods:{
    api_getUrl(){
      return this.$api.getAppImgUrl({ // api: /user/app/img/get
        master_id: this.app_id,
        key      : "banner",
      })
        .then(this.$Then(res => {
          if(res.data.length == 0){
            return
          }
          this.setAppImgIcon(res.data[0])
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 防止hover在上传文件后依旧存在
    handleMouseMove(){
      this.mouseMove = true;
    },
    // BANNER
    // 切换 开关状态
    switchBanner(){
      this.$api.setAppImgUrl({
        id: this.indexList.id,
        master_id: this.app_id,
        state: this.indexList.state,
        key: "banner",
        urls: this.indexList.urls,
      }).catch(this.$Catch(this.$I18n("get_error")))
    },
    setBannerUrl(item,index){
      this.bannerSetting = {
        data : {...item},
        index: index,
      }
      this.$refs.bannermodal.open();
    },
    banner_submit(){
      const newUrls = this.indexList.urls.map((item, index) => {
        if(index != this.bannerSetting.index){
          return item
        } else {
          return {
            ...this.bannerSetting.data,
            lang: this.bannerSetting.data.lang == 'other'?this.bannerSetting.data.other_lang :this.bannerSetting.data.lang,
          }
        }
      })
      this.api_banner(newUrls)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.indexList.urls = newUrls;
          this.$refs.bannermodal.close();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    banner_sure_delete(){
      this.$refs.bannerdeletemodal.open();
    },
    banner_delete(){
      const newUrls = this.indexList.urls.filter((_, index) => index != this.bannerSetting.index)
      
      this.indexList.urls = newUrls;
      this.api_banner(newUrls)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.indexList.urls = newUrls;
          this.$refs.bannerdeletemodal.close();
          this.$refs.bannermodal.close();
          this.bannerImage = this.indexList.urls[0] ?this.indexList.urls[0].url :"";
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_banner(newUrls){
      return this.$api.setAppImgUrl({
        id: this.indexList.id,
        master_id: this.app_id,
        state: this.indexList.state,
        key: "banner",
        urls: newUrls,
      })
       .then(() => {
        this.api_getUrl();
       });
    },
    onTwoFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files  || !files.length) return;
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.bannerImage = e.target.result;
      };

      var formData = new FormData();

      if(!files[0].type.includes("png")){
        return 
      }
      // this.isuploadimage = true;
      this.mouseMove = false;
      formData.append('myfile', files[0]);
      this.$api.uploadFile(formData)
        .then(this.$Then(res => {
          reader.readAsDataURL(files[0]);
          return this.$api.setAppImgUrl({
            id: this.indexList.id,
            master_id: this.app_id,
            state: this.indexList.state ?this.indexList.state :1,
            key: "banner",
            urls: [{
              url: res.data,
              type: 1,
              lang: this.$router.history.current.query.lang == "zh" ?"zh-CN" :"en",
              other_lang: "",
            }, ...this.indexList.urls],
          });
        }))
        .then(() => {
          this.api_getUrl();
        })
        .catch(this.$Catch(this.$I18n("get_error")))
        .then(() => {this.isuploadimage = false})
    },
    clickTwoInput(){
      this.$refs.file_two_input.click();
    },
    // 设置app_img_icon
    setAppImgIcon(data){
      this.indexList = {
        ...data,
        urls : data.urls.map(item => {
          return {
            ...item,
            lang : simpleLang.includes(item.lang) ?item.lang :"other",
            other_lang: simpleLang.includes(item.lang) ?"" :item.lang,
          }
        }),
      }

      if(this.indexList.urls.length > 0){
        this.bannerImage = this.indexList.urls[0].url
      }
    },
  },
  computed:{
    openIndexList:{ // 将 banner 开、关 从 数字变为布尔值
      set(val){
        if(val){
          this.indexList.state = 1;
        } else {
          this.indexList.state = 2;
        }
      },
      get(){
        return this.indexList.state == 1
      },
    },
    form_modalBannerData(){
      return [
        {
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            {id : 1, name : this.$I18n("show_this")},
            {id : 2, name : this.$I18n("return_to")},
          ],
          class   : "md-size-100 md-layout-item"
        },{
          label   : this.$I18n("oat_lang"),
          keys    : "lang",
          type    : "select",
          options : [
            {id : "en",    name : this.$I18n("en")},
            {id : "zh-CN", name : this.$I18n("zh-CN")},
            {id : "other", name : this.$I18n("other_lang")},
          ],
          class   : (this.bannerSetting.data.lang === "other" ?"md-size-50" :"md-size-100") + " md-layout-item no-animate",
        },{
          label: this.$I18n("oat_lang"),
          keys : "other_lang",
          type : "input",
          hide : this.bannerSetting.data.lang !== "other",
          class: "md-size-50 md-layout-item hide-label",
        },{
          label: this.$I18n("param"),
          keys : "param",
          type : "input",
          class: "md-size-100 md-layout-item",
        },
      ]
    },
  },
}
</script>
<style scoped>
  
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .loading{
    top: 4px;
    width: 128px;
    height: 128px;
    position: absolute;
    z-index: 2;
    background: rgba(255,255,255,.7);
    top:  1px;
    left: 1px;
    border-radius: 6px;
  }
  .image-box-info{
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }
  .image-box-info.hidden-mode{
    background: rgba(30,30,30,.4);
    opacity: 0;
    border-radius: 8px;
    transition: opacity 0.3s ease;
  }
  .image-box-info.hidden-mode .button,
  .image-box-info.hidden-mode .span{
    color: #FFFFFF !important;
    border-color: #FFFFFF !important;
  }
  .image-box-info.hidden-mode:hover{
    opacity: .9;
  }

  .hidden-mode .span,
  .hidden-mode .button{
    color: #FFFFFF;
    border-color: #FFFFFF;
  }

  .sub-info{
    color: #576175;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 20px;
  }
  .warn-icon{
    align-items: center;
    background: #fdded8;
    border-radius: 20px;
    color: #f94346;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 400;
    justify-content: center;
    line-height: 18px;
    margin-left: 4px;
    padding: 1px 8px;
  }
  .loading-container{
    height: 128px;
    width: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
  }
  .load-icon-small{
      color: #00bcd4 !important;
      font-size: 50px !important;
      display: inline-block;
      line-height: 50px;
  }




  .icon-image-select-box-two{
    margin: 0 6px;
    width: 168px;
    min-width: 168px;
    max-width: 168px;
    height: 76px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    background: rgba(15, 115, 230, .1);
    padding: 5px;
    position: relative;
  }
  .icon-image-select-box-two .mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 8px;
    opacity: 0;
    background: #777777;
    transition: opacity 0.3s ease;
  }
  .icon-image-select-box-two .mask:hover{
    opacity: .5;
  }
  .icon-image-select-box-two.selected{
    background: rgba(15, 115, 230, .4);
  }
  .icon-image-select-box-two .span{
    color: rgba(15, 115, 230, .8);
    font-size: 40px;
    font-weight: 600;
    line-height: 76px;
    text-align: center;
  }
  .icon-image-select-box-two .img{
    margin: -8px;
    width: 168px;
    height: 76px;
    position: absolute;
    z-index: -1;
  }
  .icon-image-select-box-two .button{
    align-items: center;
    border: 1px solid rgba(15, 115, 230, .4);
    border-radius: 6px;
    color: #0f73e6;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 600;
    height: unset;
    line-height: 14px;
    margin-bottom: 10px;
    padding: 2px 10px;
  }

  .setting-btn{
    position: absolute;
    right: 0;
    top: 0;
    background: rgba(50, 50, 50, .2);
    padding: 3px;
    border-radius: 7px;
    font-size: 16px !important;
    cursor: pointer;
  }
  .setting-btn:hover{
    background: rgb(50,50,50,.7);
  }
  .setting-btn:hover /deep/ .md-icon.md-theme-default.md-icon-font{
    color: #FFF;
  }
  .setting-btn-icon{
    font-size: 16px !important;
  }
  img{
    width: 100%;
    height: 100%;
  }
  .no-animate{
    transition: none !important;
  }
  .hide-label /deep/ label{
    opacity: 0 !important;
  }
</style>